import ImageModel from "../../../models/ImageModel"
import SignatureCanvas from 'react-signature-canvas'
import { useEffect, useState, useRef } from "react"
import { Button } from "react-bootstrap"

interface Props{
    style?:{
        marginTop?: string
        marginLeft?: string
        marginBottom?: string
        marginRight?: string
    }
    boxLabelEng: string
    boxLabelChin: string
    dataAttribute: string
    imgData: ImageModel
    setImg: (x: ImageModel) => void
    required?: boolean | undefined
}
export default function ImgUploadBox({required, style, boxLabelChin, boxLabelEng, imgData, setImg, dataAttribute}: Props){

    const [imageURL, setImageURL] = useState<any>(null);
    const sigCanvas : any = useRef({});

    /* a function that uses the canvas ref to clear the canvas 
    via a method given by react-signature-canvas */
    const clear = () => sigCanvas.current.clear();

    /* a function that uses the canvas ref to trim the canvas 
    from white spaces via a method given by react-signature-canvas
    then saves it in our state */
    const save = () =>{
        
        const base64Data = sigCanvas.current.toDataURL("image/png").replace(/^data:.+;base64,/, '');
        const byteCharacters = atob(base64Data!); // Decode Base64 string
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: "image/png" });
        const file = new File([blob], "signpng" + dataAttribute);
        setImageURL(file);
    };


    useEffect(() => {
        if(imageURL != null){
            switch (dataAttribute){
                case "Steel":{
                    setImg({...imgData, SignatureGenreSteel: dataAttribute, signatureSteel: imageURL, SignatureDocTypeSteel: "png"})
                    break
                }
                case "Chemistry":{
                    setImg({...imgData, SignatureGenreChemistry: dataAttribute, signatureChemistry: imageURL, SignatureDocTypeChemistry: "png"})
                    break
                }
                case "Signature":{
                    setImg({...imgData, SignatureGenre: dataAttribute, signature: imageURL, SignatureDocType: "png"})
                }
            }  
        }
        console.log(imgData);       
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [imageURL]);

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleUpload = (dataAttribute: string, files: FileList) =>{
        switch (dataAttribute){
            case "IdPhoto":{
                setImg({...imgData, IdPhotoGenre: dataAttribute, idPhoto: files[0], IdPhotoDocType: files.length === 0 ? "":  files[0].type.split("/")[1]})
                break
            }
            case "Chop":{
                setImg({...imgData, ChopGenre: dataAttribute, Chop: files[0], ChopDocType: files.length === 0 ? "":  files[0].type.split("/")[1]})
                break
            }
            case "Steel":{
                setImg({...imgData, SignatureGenreSteel: dataAttribute, signatureSteel: files[0], SignatureDocTypeSteel: files.length === 0 ? "":  files[0].type.split("/")[1]})
                break
            }
            case "Chemistry":{
                setImg({...imgData, SignatureGenreChemistry: dataAttribute, signatureChemistry: files[0], SignatureDocTypeChemistry: files.length === 0 ? "":  files[0].type.split("/")[1]})
                break
            }
            case "Signature":{
                setImg({...imgData, SignatureGenre: dataAttribute, signature: files[0], SignatureDocType: files.length === 0 ? "":  files[0].type.split("/")[1]})
            }
        } 
        console.log(imgData);       
    }

    return<>
                <div>
                    {/* <input type="file" accept="image/*,.pdf" onChange={(e)=>{handleUpload(dataAttribute, e.target.files!)}}></input> */}
                    {(dataAttribute === "Signature" || dataAttribute === "Steel" || dataAttribute === "Chemistry") && <><div style={{flexDirection: "row"}}>
                    <SignatureCanvas penColor='black'
                    canvasProps={{width: 180, height: 100, className: 'border border-3 border-dark sigCanvas'}} 
                    ref={sigCanvas}/>
                    </div><div style={{flexDirection: "row", justifyContent:"space-between", alignContent:"space-between"}}>
                    <Button variant="primary" style={{ borderRadius:"5px", borderWidth:"1px", padding:"10px", color:"white"}} onClick={clear}>Clear</Button>
                    <Button variant="primary" style={{ borderRadius:"5px", borderWidth:"1px", padding:"10px", color:"white"}} onClick={save}>Save</Button>
                    </div>
                    </>}
                </div>
    </>
}